import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { CreateQuestionOptionUseCaseInterface } from 'domain/usecases';

export class RemoteCreateQuestionOption
  implements CreateQuestionOptionUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: CreateQuestionOptionUseCaseInterface.Params,
  ): Promise<CreateQuestionOptionUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params,
      method: 'post',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
